// © 2026 Camp Promethean, LLC. All Rights Reserved.
import { PrometheanMark } from "@/components/PrometheanMark";
import { cn } from "@/lib/utils";

interface PrometheusAvatarProps {
  size?: "sm" | "md";
  className?: string;
}

const SIZE = {
  sm: { shell: "h-6 w-6", mark: "h-3.5 w-3.5" },
  md: { shell: "h-8 w-8", mark: "h-4 w-4" },
} as const;

export function PrometheusAvatar({ size = "md", className }: PrometheusAvatarProps) {
  const s = SIZE[size];
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-primary/10",
        s.shell,
        className,
      )}
    >
      <PrometheanMark className={s.mark} title="Prometheus" />
    </div>
  );
}
